import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Modals extends Vue {
  /**
   * 중복 비허용 여부
   */
  @Prop({ default: false }) disallowDuplication

  hide() {}

  _showModal() {
    // 중복 비허용 시 모달은 하나만 활성화 되도록 함
    if (this.disallowDuplication && this.$ustra.modal.store.currentModalComponent) {
      // @ts-ignore
      if (this._uid !== this.$ustra.modal.store.currentModalComponent._uid) {
        this.$ustra.modal.store.currentModalComponent.hide()
      }
    }

    this.$ustra.modal.store.setCurrentModalComponent(this)
  }

  _hideModal() {
    this.$ustra.modal.store.setCurrentModalComponent(null)
  }
}
